import { formatDistanceToNow, format, differenceInDays, isPast, isFuture } from 'date-fns';

export const formatDate = (date) => {
  if (!date) return 'N/A';
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'MM/dd/yyyy');
};

export const formatDateTime = (date) => {
  if (!date) return 'N/A';
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'MM/dd/yyyy HH:mm');
};

export const formatRelativeTime = (date) => {
  if (!date) return 'N/A';
  const d = typeof date === 'string' ? new Date(date) : date;
  return formatDistanceToNow(d, { addSuffix: true });
};

export const getDaysUntil = (date) => {
  if (!date) return null;
  const d = typeof date === 'string' ? new Date(date) : date;
  return differenceInDays(d, new Date());
};

export const getUrgencyStatus = (dueDate) => {
  if (!dueDate) return 'unknown';
  const days = getDaysUntil(dueDate);
  
  if (days < 0) return 'overdue';
  if (days <= 7) return 'critical';
  if (days <= 14) return 'high';
  if (days <= 30) return 'medium';
  return 'low';
};

export const getStatusColor = (status) => {
  const colors = {
    active: 'emerald',
    completed: 'cyan',
    pending: 'amber',
    pending_renewal: 'amber',
    overdue: 'rose',
    deficient: 'rose',
    draft: 'slate',
    submitted: 'cyan',
    in_review: 'slate',
    in_preparation: 'amber',
    approved: 'emerald',
    withdrawn: 'slate',
    open: 'amber',
    closed: 'slate',
    critical: 'rose',
    high: 'amber',
    medium: 'cyan',
    low: 'slate'
  };
  
  return colors[status] || 'slate';
};

export const getStatusLabel = (status) => {
  const labels = {
    active: 'Active',
    completed: 'Completed',
    pending: 'Pending',
    pending_renewal: 'Pending Renewal',
    overdue: 'Overdue',
    deficient: 'Deficient',
    draft: 'Draft',
    submitted: 'Submitted',
    in_review: 'In Review',
    in_preparation: 'In Preparation',
    approved: 'Approved',
    withdrawn: 'Withdrawn',
    open: 'Open',
    closed: 'Closed',
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low'
  };
  
  return labels[status] || status;
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const stateAbbreviations = {
  'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA',
  'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE', 'Florida': 'FL', 'Georgia': 'GA',
  'Hawaii': 'HI', 'Idaho': 'ID', 'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA',
  'Kansas': 'KS', 'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD',
  'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS', 'Missouri': 'MO',
  'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ',
  'New Mexico': 'NM', 'New York': 'NY', 'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH',
  'Oklahoma': 'OK', 'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
  'South Dakota': 'SD', 'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT',
  'Virginia': 'VA', 'Washington': 'WA', 'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY',
  'District of Columbia': 'DC'
};

export const getStateAbbr = (stateName) => {
  return stateAbbreviations[stateName] || stateName;
};


// Phone number formatting
export const formatPhoneNumber = (value) => {
  if (!value) return value;
  
  // Remove all non-numeric characters
  const phoneNumber = value.replace(/[^\d]/g, '');
  
  // Don't format if less than 4 digits
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  
  // Format as (000) 000-0000
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

export const formatPhoneInput = (e) => {
  const input = e.target;
  const formatted = formatPhoneNumber(input.value);
  input.value = formatted;
  return formatted;
};
